import { render, staticRenderFns } from "./DepartmentTop.vue?vue&type=template&id=0edbe1d4&scoped=true"
import script from "./DepartmentTop.vue?vue&type=script&lang=js"
export * from "./DepartmentTop.vue?vue&type=script&lang=js"
import style0 from "./DepartmentTop.vue?vue&type=style&index=0&id=0edbe1d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edbe1d4",
  null
  
)

export default component.exports